var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import { Grid, InputAdornment } from '@mui/material';
import { FormikTextField } from '../atoms/TextField';
import { FormikCheckboxGroup } from '../atoms/CheckboxGroup';
import PageSubmitButton from '../molecules/PageSubmitButton';
import { useNavigate } from 'react-router-dom';
import { useNotify } from '../../hooks/notificationHook';
import { preOrderRequest as apiPreOrderRequest, orderedOffer as apiOrderedOffer, } from '../../api';
import { useRequest } from '../../hooks/requestHook';
import { usePreOrderRequestItem } from '../../hooks/useListItem';
import { FormikSelectField } from '../atoms/SelectField';
import { decimalRegExp } from '../../constants/fieldFormats';
var Form = styled.form(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0px 0px 30px 0px;\n"], ["\n  margin: 0px 0px 30px 0px;\n"])));
var INITIAL_FORMIK_VALUE = {
    offer_id: '',
    processings: [],
    varieties: [],
    weight: '',
    notes: '',
};
var NewPreOrderRequestForm = function (_a) {
    var roaster = _a.roaster, offerList = _a.offerList, isRoaster = _a.isRoaster;
    var t = useTranslation().t;
    var notify = useNotify();
    var navigate = useNavigate();
    var create = useRequest(apiPreOrderRequest.create);
    var getAll = useRequest(apiOrderedOffer.getAll);
    var _b = React.useState(false), loading = _b[0], setLoading = _b[1];
    var _c = React.useState([]), orderedOffers = _c[0], setOrderedOffers = _c[1];
    var _d = usePreOrderRequestItem(), processingItems = _d.processingItems, varietyItems = _d.varietyItems;
    React.useEffect(function () {
        var canceled = false;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        return [4 /*yield*/, getAll({
                                roasterId: roaster.id,
                                offerListId: offerList.id,
                            })];
                    case 1:
                        response = _a.sent();
                        setLoading(false);
                        if (canceled || !response)
                            return [2 /*return*/];
                        setOrderedOffers(response);
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            canceled = true;
        };
    }, [getAll, roaster.id, offerList.id]);
    var handleSubmit = React.useCallback(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, create({
                            pre_order_request: __assign(__assign({ roaster_id: roaster.id, offer_list_id: offerList.id }, values), { offer_id: values.offer_id === noneOfferItem['value'] ? '' : values.offer_id }),
                        })];
                case 1:
                    response = _a.sent();
                    setLoading(false);
                    if (!response)
                        return [2 /*return*/];
                    navigate(isRoaster
                        ? "/roaster/pre_order_requests"
                        : "/admin/roasters/".concat(roaster.id, "/pre_order_requests"));
                    notify('success', [t('messages.createSuccess')]);
                    return [2 /*return*/];
            }
        });
    }); }, [t, notify, navigate, create, roaster, offerList, isRoaster]);
    var noneOfferItem = React.useMemo(function () {
        return {
            value: 'none',
            text: t('pages.preOrderRequest.lotNumberBlank'),
            disabled: offerList.preOrderRequests.some(function (_a) {
                var offer = _a.offer;
                return (offer === null || offer === void 0 ? void 0 : offer.id) === undefined;
            }),
            minOrder: '0',
        };
    }, [offerList]);
    var orderedOfferItems = React.useMemo(function () {
        if (orderedOffers.length === 0)
            return [];
        return [noneOfferItem].concat(orderedOffers.map(function (orderedOffer) { return ({
            value: orderedOffer.id,
            text: "".concat(orderedOffer.lotNumber, ", ").concat(orderedOffer.processing, ", ").concat(orderedOffer.variety),
            disabled: orderedOffer.isRequested,
            minOrder: orderedOffer.minOrder,
        }); }));
    }, [offerList, orderedOffers]);
    var validate = React.useCallback(function (values) {
        var errors = {};
        var selectedOfferItem = orderedOfferItems === null || orderedOfferItems === void 0 ? void 0 : orderedOfferItems.find(function (orderedOfferItem) { return orderedOfferItem.value === values.offer_id; });
        if (values.weight && !decimalRegExp.test(values.weight)) {
            errors.weight = t('errors.decimal', {
                field: t("params.preOrderRequest.weight"),
            });
        }
        if (!selectedOfferItem ||
            selectedOfferItem.value === noneOfferItem['value'])
            return errors;
        if (!values.weight) {
            errors.weight = t('errors.isRequired', {
                field: t("params.preOrderRequest.weight"),
            });
        }
        if (values.weight &&
            Number(values.weight) < Number(selectedOfferItem.minOrder)) {
            errors.weight = t('errors.mustOverOfferMinOrderWeight', {
                minOrder: selectedOfferItem.minOrder,
            });
        }
        return errors;
    }, [t, orderedOfferItems]);
    var formik = useFormik({
        initialValues: INITIAL_FORMIK_VALUE,
        onSubmit: handleSubmit,
        validate: validate,
        validateOnMount: true,
        validateOnChange: true,
        enableReinitialize: true,
    });
    return (React.createElement(Form, { onSubmit: formik.handleSubmit },
        React.createElement(Grid, { container: true, spacing: 3, style: { marginTop: 5 } },
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikSelectField, { label: t('params.offer.lotNumber'), name: "offer_id", items: orderedOfferItems, fullWidth: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 12 },
                React.createElement(FormikCheckboxGroup, { label: t('params.preOrderRequest.processing'), name: "processings", items: processingItems, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 12 },
                React.createElement(FormikCheckboxGroup, { label: t('params.preOrderRequest.variety'), name: "varieties", items: varietyItems, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { label: t('params.preOrderRequest.weight'), name: "weight", InputProps: {
                        endAdornment: React.createElement(InputAdornment, { position: "end" }, "Kg"),
                    }, inputProps: {
                        style: {
                            textAlign: 'right',
                        },
                    }, fullWidth: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormikTextField, { fullWidth: true, multiline: true, rows: 4, name: "notes", label: t("params.preOrderRequest.notes"), formik: formik }))),
        React.createElement(PageSubmitButton, { disabled: !formik.isValid || loading }, t('buttons.create'))));
};
export default NewPreOrderRequestForm;
var templateObject_1;
